import { slide as Menu } from "react-burger-menu";
import { useState } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiHome, FiGrid, FiPhone, FiClock, FiSettings, FiFilter, FiBold, FiFacebook, FiInstagram, FiTwitter, FiLinkedin } from "react-icons/fi";
import { BsPerson } from "react-icons/bs";

// CSS
import "./Menu.scss";

function MainMenu() {
  const [toggle, setToggle] = useState(false);

  return <div></div>;
}
export default MainMenu;
